/**
 * LUXURY GIFTING BLOCK v7 - luxury-gifting-block.js
 * CRAFT THEME (Dawn-based) - annabeljewellery.com
 *
 * v7 changes:
 * 1. Total now follows the selected variant (was stuck on page-load price)
 * 2. Quantity included in summary total
 * 3. ATC button price no longer goes stale / doubles after variant change
 * 4. Card validation guard survives variant change (delegated listener)
 * 5. Gift bow added BEFORE main product so the cart drawer shows both.
 *    If the bow fails, the add stops instead of silently skipping the charge.
 *
 * v8 changes (Oct 2026):
 * 1. Express buttons (Buy it now, Buy with Shop, Apple Pay, Google Pay,
 *    PayPal) used to post the form straight to checkout and skipped the bow
 *    add, so orders showed "Gift Presentation: Yes" with no £5 charge and no
 *    message. While gift presentation is ON, a click on these buttons now
 *    adds product + bow (with message) and sends the shopper straight to
 *    the Shop Pay page (Buy with Shop) or checkout (other buttons).
 *    With gift OFF the buttons work exactly as before.
 * 2. "Gift Presentation" is no longer written to the form as a hidden field.
 *    It is only set inside the Add to Bag intercept, together with the bow.
 */

(function () {
  'use strict';

  var CFG = {
    giftHandle:     'satin-gift-bow',
    giftVariantId:  null,
    giftPricePence: 500,
  };

  var S = {
    cardOpen:       false,
    giftOpen:       false,
    activeOcc:      null,
    selCardId:      null,
    selCardLabel:   null,
    carOffset:      0,
    visCards:       [],
    perPage:        3,
    basePricePence: 0,
    touched:        false,
  };

  var D = {};

  var VARIANTS      = null;
  var lastVariantId = null;
  var syncTimer     = null;
  var PRICE_SUFFIX  = /\s*—\s*£[\d.,]+\s*$/;

  /* ══════════════════════════════════════════════════
     INIT
  ══════════════════════════════════════════════════ */
  function init() {
    D.root = document.getElementById('luxuryGiftingBlock');
    if (!D.root) return;

    D.hdrCard       = document.getElementById('lgb-hdr-card');
    D.bodyCard      = document.getElementById('lgb-body-card');
    D.circCard      = document.getElementById('lgb-circle-card');
    D.ctaCard       = document.getElementById('lgb-card-cta');
    D.removeCard    = document.getElementById('lgb-card-remove');
    D.pills         = D.root.querySelectorAll('.lgb__pill');
    D.allCards      = D.root.querySelectorAll('.lgb__card');
    D.track         = document.getElementById('lgb-track');
    D.viewport      = document.getElementById('lgb-viewport');
    D.prevBtn       = document.getElementById('lgb-prev');
    D.nextBtn       = document.getElementById('lgb-next');
    D.pOcc          = document.getElementById('lgb-p-occasion');
    D.pCard         = document.getElementById('lgb-p-card');
    D.hdrGift       = document.getElementById('lgb-hdr-gift');
    D.bodyGift      = document.getElementById('lgb-body-gift');
    D.circGift      = document.getElementById('lgb-circle-gift');
    D.ctaGift       = document.getElementById('lgb-gift-cta');
    D.giftMsg       = document.getElementById('lgb-gift-msg');
    D.charN         = document.getElementById('lgb-char-n');
    D.giftBadge     = document.getElementById('lgb-gift-price-badge');
    D.pGift         = document.getElementById('lgb-p-gift');
    D.sumBasePrice  = document.getElementById('lgb-sum-base-price');
    D.sumBaseQty    = document.getElementById('lgb-sum-base-qty');
    D.sumCard       = document.getElementById('lgb-sum-card');
    D.sumCardDetail = document.getElementById('lgb-sum-card-detail');
    D.sumGift       = document.getElementById('lgb-sum-gift');
    D.sumGiftPrice  = document.getElementById('lgb-sum-gift-price');
    D.sumTotal      = document.getElementById('lgb-sum-total');
    D.cardError     = document.getElementById('lgb-card-error');

    S.basePricePence = parseInt(D.root.dataset.basePrice || '0', 10);

    bindEvents();
    detectPerPage();

    var fp = D.root.querySelector('.lgb__pill--on');
    if (fp) setOccasion(fp.dataset.occ, true);

    fetchGiftProduct();
    loadVariantPrices();
    watchVariantChange();
    interceptAtcButton();
    interceptExpressButtons();
    updateSummary();
  }

  /* ══════════════════════════════════════════════════
     FORM HELPERS
  ══════════════════════════════════════════════════ */
    function atcForm() {
    var btn = document.querySelector('form[action*="/cart/add"] [name="add"]');
    return btn ? btn.closest('form') : document.querySelector('form[action*="/cart/add"]:not(.installment)');
  }

  function atcButton() {
    var form = atcForm();
    return form && form.querySelector('[type="submit"][name="add"], button[name="add"]');
  }

  function currentVariantId() {
    var form  = atcForm();
    var input = form && form.querySelector('[name="id"]');
    var id    = input ? parseInt(input.value, 10) : NaN;
    return isNaN(id) ? null : id;
  }

  function currentQty() {
    var q = document.querySelector('product-info input[name="quantity"]') ||
            document.querySelector('input[name="quantity"]');
    var n = q ? parseInt(q.value, 10) : 1;
    return (isNaN(n) || n < 1) ? 1 : n;
  }

  function currentTotal() {
    return S.basePricePence * currentQty() + (S.giftOpen ? CFG.giftPricePence : 0);
  }

  /* ══════════════════════════════════════════════════
     VARIANT SYNC
     Craft/Dawn re-renders only price + buy buttons on
     variant change, not this block. So we detect the
     change ourselves and re-read the variant price.
  ══════════════════════════════════════════════════ */
  async function loadVariantPrices() {
    try {
      var handle = D.root.dataset.productHandle ||
                   (window.location.pathname.split('/products/')[1] || '').split(/[?#]/)[0];
      if (!handle) return;
      var res = await fetch('/products/' + handle + '.js');
      if (!res.ok) throw new Error('HTTP ' + res.status);
      var data = await res.json();
      VARIANTS = {};
      data.variants.forEach(function (v) { VARIANTS[v.id] = v.price; });
      lastVariantId = null;
      syncBasePrice();
    } catch (e) {
      console.error('[LGB] variant prices failed:', e.message);
    }
  }

  function syncBasePrice() {
    var id = currentVariantId();
    if (!id || id === lastVariantId) return;
    lastVariantId = id;
    if (!VARIANTS || VARIANTS[id] == null) return;
    S.basePricePence = VARIANTS[id];
    D.root.dataset.basePrice = String(VARIANTS[id]);
    updateSummary();
  }

  function scheduleSync() {
    clearInterval(syncTimer);
    var tries = 0;
    syncTimer = setInterval(function () {
      syncBasePrice();
      if (++tries > 25) clearInterval(syncTimer);
    }, 100);
  }

  function onPageMutate() {
    syncBasePrice();
    updateAtcBtn(currentTotal());
  }

  function watchVariantChange() {
    var scope = document.querySelector('product-info') || atcForm();
    if (scope) {
      new MutationObserver(onPageMutate).observe(scope, { childList: true, subtree: true });
    }
    document.addEventListener('change', function (e) {
      var t = e.target;
      if (!t || !t.closest) return;
      if (t.name === 'quantity') { updateSummary(); return; }
      if (t.closest('variant-selects, variant-radios, .product-form__input')) scheduleSync();
    });
  }

  /* ══════════════════════════════════════════════════
     ATC INTERCEPT
  ══════════════════════════════════════════════════ */
  function ensureGiftVariant() {
    return new Promise(function (resolve, reject) {
      var waited = 0;
      (function check() {
        if (CFG.giftVariantId) return resolve();
        if (waited >= 4000) return reject(new Error('Gift presentation is still loading. Please try again.'));
        waited += 200;
        setTimeout(check, 200);
      })();
    });
  }

  function interceptAtcButton() {
    var originalFetch = window.fetch;

    // Delegated capture listener: survives Dawn replacing the button on variant change
    document.addEventListener('click', function (e) {
      var btn = e.target.closest && e.target.closest('[name="add"]');
      if (!btn || !btn.closest('form[action*="/cart/add"]')) return;
      if (S.cardOpen && !S.selCardId) {
        e.preventDefault();
        e.stopImmediatePropagation();
        showCardError();
      }
    }, true);

    window.fetch = function (url, options) {
      var isAdd = typeof url === 'string' &&
                  url.indexOf('/cart/add') !== -1 &&
                  options && options.body instanceof FormData;

      if (!isAdd || options.body.get('properties[_lgb_gift]')) {
        return originalFetch.apply(this, arguments);
      }

      if (S.cardOpen && !S.selCardId) {
        showCardError();
        return Promise.reject(new Error('LGB_VALIDATION: card design not selected'));
      }
      hideCardError();

      var body = options.body;
      if (S.cardOpen && S.activeOcc)    body.set('properties[Gift Occasion]', S.activeOcc);
      if (S.cardOpen && S.selCardLabel) body.set('properties[Message Card]',  S.selCardLabel);
      if (S.giftOpen)                   body.set('properties[Gift Presentation]', 'Yes');

      if (!S.giftOpen) return originalFetch.apply(this, arguments);

      var self = this, args = arguments;

      // Bow FIRST, then main product. Main response (with sections) then
      // includes both items, so the cart drawer renders correctly.
      return ensureGiftVariant()
        .then(function () {
          var bow = new FormData();
          bow.append('id', CFG.giftVariantId);
          bow.append('quantity', 1);
          bow.append('properties[_lgb_gift]', '1');
          if (D.giftMsg && D.giftMsg.value.trim()) {
            bow.append('properties[Gift Own Message]', D.giftMsg.value.trim());
          }
          return originalFetch('/cart/add.js', {
            method:  'POST',
            headers: { 'X-Requested-With': 'XMLHttpRequest', 'Accept': 'application/json' },
            body:    bow,
          });
        })
        .then(function (r) {
          return r.json().then(function (j) {
            if (!r.ok || j.status) {
              throw new Error(j.description || j.message || 'Gift presentation could not be added. Please try again.');
            }
            return j;
          });
        })
        .then(function (bowItem) {
          return originalFetch.apply(self, args).then(function (resp) {
            // Main product failed (e.g. out of stock): remove the orphan bow
            if (!resp.ok && bowItem && bowItem.key) {
              originalFetch('/cart/change.js', {
                method:  'POST',
                headers: { 'Content-Type': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
                body:    JSON.stringify({ id: bowItem.key, quantity: 0 }),
              });
            }
            return resp;
          });
        })
        .catch(function (err) {
          if (String(err && err.message).indexOf('LGB_') !== 0) {
            alert((err && err.message) || 'Sorry, something went wrong. Please try again.');
          }
          throw err;
        });
    };
  }

  /* ══════════════════════════════════════════════════
     EXPRESS BUTTONS (Buy it now / Buy with Shop / wallets)
     They post the form straight to checkout and never hit the
     Add to Bag intercept. While gift is ON, catch the click,
     add product + bow via the normal flow, then go to checkout.
     ══════════════════════════════════════════════════ */
  var expressBusy = false;

  function interceptExpressButtons() {
    document.addEventListener('click', function (e) {
      if (!S.giftOpen) return;
      var path = e.composedPath ? e.composedPath() : [];
      var hit = path.some(function (n) {
        return n && n.classList && n.classList.contains('shopify-payment-button');
      });
      if (!hit) return;
      // Buy with Shop -> straight to the Shop Pay page; other buttons -> checkout
      var isShopPay = path.some(function (n) {
        return n && n.tagName === 'SHOP-PAY-WALLET-BUTTON';
      });
      var form = atcForm();
      if (!form) return;

      e.preventDefault();
      e.stopPropagation();
      e.stopImmediatePropagation();

      if (S.cardOpen && !S.selCardId) { showCardError(); return; }
      if (expressBusy) return;
      expressBusy = true;

      // Goes through the patched fetch above, so the bow + message are added
      window.fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'X-Requested-With': 'XMLHttpRequest', 'Accept': 'application/json' },
        body: new FormData(form),
      })
        .then(function (r) {
          if (r.ok) {
            window.location.href = isShopPay ? '/checkout?payment=shop_pay' : '/checkout';
            return;
          }
          return r.json().then(function (j) {
            expressBusy = false;
            alert(j.description || j.message || 'Sorry, this item could not be added. Please try again.');
          });
        })
        .catch(function (err) {
          expressBusy = false;
          console.error('[LGB] express checkout failed:', err && err.message);
        });
    }, true);
  }

  /* ── EVENTS ── */
  function bindEvents() {
    D.hdrCard.addEventListener('click', function (e) {
      if (e.target.closest('.lgb__textlink')) return;
      openCard(!S.cardOpen);
    });
    D.ctaCard.addEventListener('click', function (e) { e.stopPropagation(); openCard(true); });
    D.removeCard.addEventListener('click', function () { openCard(false); });
    D.hdrCard.addEventListener('keydown', function (e) {
      if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); openCard(!S.cardOpen); }
    });

    D.hdrGift.addEventListener('click', function (e) {
      if (e.target.closest('.lgb__textlink')) return;
      openGift(!S.giftOpen);
    });
    D.ctaGift.addEventListener('click', function (e) { e.stopPropagation(); openGift(true); });
    D.hdrGift.addEventListener('keydown', function (e) {
      if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); openGift(!S.giftOpen); }
    });

    D.pills.forEach(function (p) {
      p.addEventListener('click', function () { setOccasion(p.dataset.occ); });
    });

    D.allCards.forEach(function (c) {
      c.addEventListener('click', function () { selectCard(c); });
      c.addEventListener('keydown', function (e) {
        if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); selectCard(c); }
      });
    });

    D.prevBtn.addEventListener('click', function () { shiftCar(-1); });
    D.nextBtn.addEventListener('click', function () { shiftCar(1); });

    D.giftMsg.addEventListener('input', function () {
      D.charN.textContent = D.giftMsg.value.length;
    });

    window.addEventListener('resize', debounce(function () {
      detectPerPage(); layoutCar(); updateArrows();
    }, 150));
  }

  /* ── SECTIONS ── */
  function openCard(on) {
    S.touched = true;
    S.cardOpen = on;
    D.bodyCard.classList.toggle('open', on);
    D.bodyCard.setAttribute('aria-hidden', String(!on));
    D.hdrCard.setAttribute('aria-expanded', String(on));
    D.circCard.classList.toggle('on', on);
    if (!on) { clearCardSel(); hideCardError(); }
    pushToForm();
    updateSummary();
  }

  function openGift(on) {
    S.touched = true;
    S.giftOpen = on;
    D.bodyGift.classList.toggle('open', on);
    D.bodyGift.setAttribute('aria-hidden', String(!on));
    D.hdrGift.setAttribute('aria-expanded', String(on));
    D.circGift.classList.toggle('on', on);
    D.giftMsg.disabled = !on;
    if (!on) { D.giftMsg.value = ''; D.charN.textContent = '0'; }
    pushToForm();
    updateSummary();
  }

  function setOccasion(occ, silent) {
    S.activeOcc = occ; S.carOffset = 0;
    D.pills.forEach(function (p) {
      var on = p.dataset.occ === occ;
      p.classList.toggle('lgb__pill--on', on);
      p.setAttribute('aria-selected', String(on));
    });
    D.allCards.forEach(function (c) {
      c.classList.toggle('vis', c.dataset.occ === occ);
    });
    if (S.selCardId) {
      var cur = D.root.querySelector('.lgb__card[data-cid="' + S.selCardId + '"]');
      if (cur && cur.dataset.occ !== occ) clearCardSel();
    }
    rebuildVisCards();
    D.pOcc.value = occ;
    if (!silent && S.cardOpen) pushToForm();
  }

  function rebuildVisCards() {
    S.visCards = Array.from(D.allCards).filter(function (c) {
      return c.classList.contains('vis');
    });
    layoutCar(); updateArrows();
  }

  function selectCard(card) {
    S.touched = true;
    var id = card.dataset.cid, label = card.dataset.clabel;
    if (S.selCardId === id) { clearCardSel(); pushToForm(); updateSummary(); return; }
    clearCardSel();
    card.classList.add('sel'); card.setAttribute('aria-checked', 'true');
    S.selCardId = id; S.selCardLabel = label; D.pCard.value = label;
    hideCardError();
    pushToForm(); updateSummary();
  }

  /* ── VALIDATION ERROR ── */
  function showCardError() {
    if (!D.cardError) return;
    D.cardError.style.display = '';
    D.cardError.scrollIntoView({ behavior: 'smooth', block: 'center' });
    D.viewport && D.viewport.classList.add('lgb__viewport--error');
  }

  function hideCardError() {
    if (!D.cardError) return;
    D.cardError.style.display = 'none';
    D.viewport && D.viewport.classList.remove('lgb__viewport--error');
  }

  function clearCardSel() {
    D.allCards.forEach(function (c) {
      c.classList.remove('sel'); c.setAttribute('aria-checked', 'false');
    });
    S.selCardId = null; S.selCardLabel = null; D.pCard.value = '';
  }

  /* ── CAROUSEL ── */
  function detectPerPage() { S.perPage = window.innerWidth < 480 ? 1 : 2; }

  function shiftCar(dir) {
    var max = Math.max(0, S.visCards.length - S.perPage);
    S.carOffset = Math.min(Math.max(S.carOffset + dir, 0), max);
    layoutCar(); updateArrows();
  }

  function layoutCar() {
    if (!D.viewport || S.visCards.length === 0) return;
    var gap = 8;
    var vw = D.viewport.offsetWidth;
    var cardW = Math.floor((vw - gap * (S.perPage - 1)) / S.perPage);
    S.visCards.forEach(function (c) { c.style.width = cardW + 'px'; });
    D.track.style.transform = 'translateX(-' + (S.carOffset * (cardW + gap)) + 'px)';
  }

  function updateArrows() {
    var max = Math.max(0, S.visCards.length - S.perPage);
    D.prevBtn.disabled = S.carOffset <= 0;
    D.nextBtn.disabled = S.carOffset >= max;
  }

  /* ── SUMMARY ── */
  function updateSummary() {
    var qty  = currentQty();
    var line = S.basePricePence * qty;

    if (D.sumBasePrice) D.sumBasePrice.textContent = moneyGBP(line);
    if (D.sumBaseQty)   D.sumBaseQty.textContent   = qty > 1 ? ' × ' + qty : '';

    if (S.cardOpen) {
      D.sumCard.style.display = '';
      D.sumCardDetail.textContent = S.selCardLabel
        ? (S.activeOcc + ' — ' + S.selCardLabel)
        : (S.activeOcc || '');
    } else {
      D.sumCard.style.display = 'none';
      D.sumCardDetail.textContent = '';
    }
    D.sumGift.style.display = S.giftOpen ? '' : 'none';

    var total = line + (S.giftOpen ? CFG.giftPricePence : 0);
    if (D.sumTotal) D.sumTotal.textContent = moneyGBP(total);
    updateAtcBtn(total);
  }

  function updateAtcBtn(totalPence) {
    if (!S.touched) return;
    var btn = atcButton();
    if (!btn || btn.disabled) return;
    var span = btn.querySelector('span:not(.loading__spinner):not(.loading-overlay__spinner)') || btn;
    var base = span.textContent.replace(PRICE_SUFFIX, '').trim();
    var want = base + ' — ' + moneyGBP(totalPence);
    if (span.textContent !== want) span.textContent = want;
  }

  /* ── FORM SYNC ── */
  function pushToForm() {
    var form = atcForm();
    if (!form) return;
    var pairs = [
      ['properties[Gift Occasion]',     S.cardOpen && S.activeOcc    ? S.activeOcc    : ''],
      ['properties[Message Card]',      S.cardOpen && S.selCardLabel ? S.selCardLabel : ''],
    ];
    // Gift Presentation is set only in the Add to Bag intercept (with the bow)
    var oldGp = form.querySelector('[name="properties[Gift Presentation]"]');
    if (oldGp) oldGp.remove();
    pairs.forEach(function (pair) {
      var name = pair[0], val = pair[1];
      var el = form.querySelector('[name="' + CSS.escape(name) + '"]');
      if (!el) {
        el = document.createElement('input');
        el.type = 'hidden'; el.name = name;
        form.appendChild(el);
      }
      el.value = val;
    });
  }

  /* ── FETCH GIFT PRODUCT ── */
  async function fetchGiftProduct() {
    try {
      var res = await fetch('/products/' + CFG.giftHandle + '.js');
      if (!res.ok) throw new Error('HTTP ' + res.status);
      var data = await res.json();
      CFG.giftVariantId  = data.variants[0].id;
      CFG.giftPricePence = data.variants[0].price;
      if (D.giftBadge)    D.giftBadge.textContent    = '+' + moneyGBP(CFG.giftPricePence);
      if (D.sumGiftPrice) D.sumGiftPrice.textContent = moneyGBP(CFG.giftPricePence);
      updateSummary();
    } catch (e) {
      console.error('[LGB] fetchGiftProduct failed:', e.message);
    }
  }

  /* ── UTILS ── */
  function moneyGBP(p) { return '£' + (p / 100).toFixed(2); }
  function debounce(fn, ms) {
    var t;
    return function () {
      var a = arguments;
      clearTimeout(t);
      t = setTimeout(function () { fn.apply(null, a); }, ms);
    };
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

})();